<template>
  <header
    ref="header"
    class="header"
    :class="{
      'header-hide': hideHeader,
      'header-detail': isDetail,
      'header-popup': isPopup,

      'header-scroll': percent > 0
    }"
  >
    <div class="header-inner">
      <h1 v-if="!isPopup" :class="{ 'hidden': isDetail }">
        <logo @click.native="onPageMove" />
      </h1>
      <button
        v-if="isDetail && !isPopup"
        type="button"
        class="header-back"
        :title="$t('back')"
        @click="goBack"
      >
        <icon-arrow />
      </button>

      <button
        v-if="isPopup"
        type="button"
        class="header-close"
        :title="$t('close')"
        @click="goBack"
      >
        <icon-close />
      </button>

      <div v-if="!isPopup" class="header-nav" :class="{ 'header-nav-open': isHeaderOpen }">
        <nav class="header-global">
          <ul
            ref="globalNav"
            class="header-global-nav"
            :class="{ 'hover': isHeaderHover }"
            @mouseenter="() => {isHeaderHover = true}"
            @mouseleave="() => {isHeaderHover = false}"
          >
            <li>
              <strong>
                <router-link
                  :to="{name: 'Company', params : { ...localeParams }}"
                  @click.native="onPageMove({
                    ga: {
                      action: 'click',
                      name: 'GNB_회사소개',
                      category: 'GNB',
                      label: 'depth_1',
                      page: '공통'
                    }
                  })"
                >
                  {{ $t('menuCompany.company') }}
                </router-link>
                <button type="button" @click="onToggle">
                  <icon-chevron-down />
                </button>
              </strong>
              <div class="header-global-sub">
                <ul>
                  <li>
                    <router-link
                      :to="{name: 'company-culture', params : { ...localeParams }}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuCompany.woowaCulture') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{name: 'company-history', params : { ...localeParams }}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuCompany.history') }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <strong>
                <router-link
                  :to="{name: 'Service', params : { ...localeParams }}"
                  @click.native="onPageMove({
                    ga: {
                      action: 'click',
                      name: 'GNB_서비스',
                      category: 'GNB',
                      label: 'depth_1',
                      page: '공통'
                    }
                  })"
                >
                  {{ $t('menuService.service') }}
                </router-link>
                <button type="button" @click="onToggle">
                  <icon-chevron-down />
                </button>
              </strong>
              <div class="header-global-sub">
                <ul>
                  <li>
                    <router-link
                      :to="{name: 'service-order', params : { ...localeParams }}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuService.deliveryTakeout') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{name: 'service-commerce', params : { ...localeParams }}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuService.commerce') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{name: 'service-ceo', params : { ...localeParams }}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuService.vendorsRiders') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{name: 'service-culture', params : { ...localeParams }}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuService.culture') }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <strong>
                <router-link
                  :to="{name: 'Sustainability', params : { ...localeParams }}"
                  @click.native="onPageMove({
                    ga: {
                      action: 'click',
                      name: 'GNB_지속가능경영',
                      category: 'GNB',
                      label: 'depth_1',
                      page: '공통'
                    }
                  })"
                >
                  {{ $t('menuSustainability.sustainability') }}
                </router-link>
                <button type="button" @click="onToggle">
                  <icon-chevron-down />
                </button>
              </strong>
              <div class="header-global-sub">
                <ul>
                  <li>
                    <router-link
                      :to="{name: 'sustainability-happiness', params : { ...localeParams }}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuSustainability.happiness') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{name: 'sustainability-together', params : { ...localeParams, category: 0 }}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuSustainability.togetherValue') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{name: 'sustainability-responsibility', params : { ...localeParams }}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuSustainability.responsibility') }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <strong>
                <router-link
                  :to="{name: 'Newsroom', params : { ...localeParams }, query : {page : 1}}"
                  @click.native="onPageMove({
                    ga: {
                      action: 'click',
                      name: 'GNB_뉴스룸',
                      category: 'GNB',
                      label: 'depth_1',
                      page: '공통'
                    }
                  })"
                >
                  {{ $t('menuNewsroom.newsroom') }}
                </router-link>
                <button type="button" @click="onToggle">
                  <icon-chevron-down />
                </button>
              </strong>
              <div class="header-global-sub">
                <ul>
                  <li>
                    <router-link
                      :to="{name: 'NewsroomReport', params : { ...localeParams }, query : {page : 1}}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuNewsroom.press') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{name: 'NewsroomMedia', params : { ...localeParams }, query : {page : 1}}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuNewsroom.release') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{name: 'NewsroomFact', params : { ...localeParams }, query : {page : 1}}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuNewsroom.factCheck') }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <family />
        </nav>

        <div class="header-aside">
          <family />
          <div class="header-aside-top">
            <div
              class="header-lang"
              :class="{
                active: toggleLang
              }"
            >
              <button type="button" @click="onToggleLang">
                {{ locale === 'ko' ? 'KR' : 'EN ' }}
                <icon-chevron-down />
              </button>
              <ul class="header-lang-list">
                <li>
                  <button type="button" :disabled="locale === 'ko'" @click="onChangeTranslate('ko')">KR</button>
                </li>
                <li>
                  <button type="button" :disabled="locale === 'en'" @click="onChangeTranslate('en')">EN</button>
                </li>
              </ul>
            </div>

            <button
              type="button"
              class="header-open"
              @click="onHeaderOpen"
            >
              <i />
              <i />
              <i />
            </button>
          </div>
        </div>
      </div>

      <i class="header-dim" />
    </div>

    <i class="header-progress" :style="`--percent:${percent}%`" />
  </header>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import menu from '@/mixins/menu'
  import gtag from '@/mixins/gtag'

  export default {
    components: {
      iconClose: () => import('@/static/svg/close.svg'),
      iconChevronDown: () => import('@/static/svg/chevron-down-menu.svg'),
      iconArrow: () => import('@/static/svg/arrow.svg'),
      logo: () => import('@/components/base/Logo.vue'),
      family: () => import('./Family.vue'),
    },
    mixins: [
      menu,
      gtag
    ],
    data () {
      return {
        isHeaderOpen: false,
        isHeaderHover: false,
        hideHeader: false,
        scrollOffset: null,
        offsetTop: 0,
        percent: 0,
        toggleLang: false
      }
    },
    computed: {
      ...mapGetters({
        locale: 'locale/GET_LOCALE',
        siteConnectionLevelFirst: 'site/siteConnectionLevelFirst',
        siteConnectionLevelSecond: 'site/siteConnectionLevelSecond',
        writingCategories: 'categories/get_writing_categories'
      }),
      isDetail () {
        const details = ['writingDetail', 'newsroomReportDetail', 'newsroomFactDetail', 'NoticeDetail', 'NewsroomSearch']

        return details.includes(this.$route.name)
      },
      isPopup () {
        const popups = ['FontsLicense', 'MusicLicense']

        return popups.includes(this.$route.name)
      }
    },
    watch: {
      $route: {
        handler (to, from) {
          this.percent = 0
          this.isHeaderOpen = false
        },
        // deep: true
      },
      '$route.params.locale' () {
        document.documentElement.scrollTop = 0
      },
    },
    methods: {
      ...mapActions({
        localeChange: 'locale/localeChange'
      }),
      goBack () {
        // TODO: route 다시 고민
        this.$router.go(-1)
      },
      onHeaderOpen () {
        this.isHeaderOpen = !this.isHeaderOpen

        if (this.isHeaderOpen) {
          this.offsetTop = window.scrollY || window.pageYOffset
        }

        if (!this.isHeaderOpen) {
          this.onHeaderClose()
        }
      },
      onHeaderClose () {
        const openNav = document.querySelectorAll('.active')
        document.documentElement.scrollTop = this.offsetTop

        Array.from(openNav).forEach(item => {
          item.classList.remove('active')
        })
      },
      onPageMove (obj) {
        this.isHeaderOpen = false
        document.documentElement.scrollTo({
          top: 0,
          behavior: 'smooth'
        })

        this.$refs.globalNav && this.$refs.globalNav.classList.remove('hover')

        obj && obj.ga && this.setGtag(obj.ga)
      },
      onChangeTranslate (lang) {
        window.localStorage.setItem('lang', lang)

        this.localeChange({
          lang,
          query: this.$route.query
        })
      },
      onToggle (e) {
        const $li = e.target.closest('li')

        $li.classList.toggle('active')
      },
      onToggleLang () {
        this.toggleLang = !this.toggleLang

        const clickEvent = (e) => {
          if (!e.target.closest('.header-lang') || e.target.parentNode.nodeName === 'LI') {
            this.toggleLang = false
            window.removeEventListener('click', clickEvent)
          }
        }

        window.addEventListener('click', clickEvent)
      }
    }
  }
</script>
